<template>
  <app-button
    class="polyOfficeIconParent"
    data-locator="import-from-poly-button"
    type="outlined"
    variant="neutral"
    @click="handleClick"
  >
    <template #left-icon>
      <app-icon-poly-office />
    </template>
    {{ $t('common.filders.ExternalFildersSelector.importFromPoly') }}
  </app-button>
</template>

<script>
export default {
  name: 'PolyOfficeButtonImport',
  methods: {
    handleClick () {
      this.$emit('polyOfficeOpenDialog')
    },
  },
}
</script>
